import { useState, useEffect } from 'react';
import classNames from 'classnames';
import FJButton, { FJButtonType } from '@src/common/components/FJButton/FJButton';
import FJModalClose from '../FJModalClose/FJModalClose';
import FJCheckBox from '@src/components/FJCheckBox/FJCheckBox';
import FJLocalStore from '@src/store/FJLocalStore';
import styles from './FJDislikeReasonsModal.module.less';
import FJScroller from '@src/common/components/FJScroller/FJScroller';

interface FJDislikeReasonsModalProps {
    onCancel: () => void;
    onSubmit: (keys: string[]) => void;
    display: boolean;
}

const REASON_KEYS: string[] = [
    'information-was-cut-off',
    'the-specified-clip-wasnt-captured',
    'the-subject-isnt-cropped-correctly',
    'inaccurate-subtitles',
    'title-doesnt-match-content',
    'clip-length-is-unreasonable',
    'rating-is-unreasonable',
];

export default function FJDislikeReasonsModal({ onCancel, onSubmit, display }: FJDislikeReasonsModalProps) {
    const [selected, setSelected] = useState<string[]>([]);
    useEffect(() => {
        if (!display) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            setSelected([]);
        }
    }, [display]);
    const toggleReason = (key: string, nextSelected: boolean) => {
        setSelected(prev =>
            nextSelected ? (prev.includes(key) ? prev : [...prev, key]) : prev.filter(k => k !== key),
        );
    };

    const handleSubmit = () => {
        if (!selected.length) return;
        onSubmit(selected);
    };

    return (
        <section className={styles.fj_dislike_modal}>
            <FJModalClose onClick={onCancel} />
            <h2 className={styles.title}>{FJLocalStore._('tell-us-why-you-dislike-it')}</h2>
            <p className={styles.subtitle}>
                {FJLocalStore._('please-select-the-reasons-your-feedback-helps-us-improve')}
            </p>

            <FJScroller className={styles.reason_list}>
                {REASON_KEYS.map(key => (
                    <FJCheckBox
                        className={classNames(styles.reason_checkbox, selected.includes(key) && styles.selected)}
                        key={key}
                        value={FJLocalStore._(key)}
                        selected={selected.includes(key)}
                        dataChange={next => {
                            toggleReason(key, next);
                        }}
                    />
                ))}
            </FJScroller>

            <div className={styles.footer}>
                <FJButton className={styles.btn_cancel} type={FJButtonType.DEFAULT} text='cancel' onClick={onCancel} />
                <FJButton
                    className={styles.btn_submit}
                    type={FJButtonType.GRADIENT}
                    text='submit'
                    disabled={selected.length === 0}
                    onClick={handleSubmit}
                />
            </div>
        </section>
    );
}
